import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { PurchasePopup } from './components/PurchasePopup';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { ComboSelector } from './components/ComboSelector';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const pixelId = '1245152907821897';
    // Initialize fbq
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Load the pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Init and track PageView
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main className="pt-12" data-id="element-3">
        {' '}
        {/* Padding top to account for fixed urgency bar */}
        <HeroSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <ComboSelector data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTA data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
      </main>

      <FooterSection data-id="element-14" />
    </div>;
}